export default __webpack_public_path__ + "static/media/Promo-Facebook-Facebook image post (2).748dfc20.jpeg";